module.exports = __webpack_public_path__ + "static/media/image5.fe68523c.jpeg";